import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import "./CreateShipment.css";
import { Table } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import alertify from "alertifyjs";


const ShipmentEarly = () => {
  const [data, setData] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [checkboxStatus, setCheckboxStatus] = useState({});
  const [isCreatingShipment, setIsCreatingShipment] = useState(false);

 const [reverseOrder] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const response = await Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`);
      const reversedData = reverseOrder
        ? response.data.reverse()
        : response.data;
      setData(reversedData);
    };

    fetchData();
  }, [reverseOrder]);

  const filteredData = data.filter((row) => row.ApprovalDate !== null);

  const navigate = useNavigate();

  const handleInputChange = (shipmentid, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [shipmentid]: value,
    }));
  };

  const handleCheckboxChange = (shipmentid) => {
    setCheckboxStatus((prevStatus) => ({
      ...prevStatus,
      [shipmentid]: !prevStatus[shipmentid], 
    }));
    if (selectedShipments.includes(shipmentid)) {
      setSelectedShipments((prevSelected) =>
        prevSelected.filter((id) => id !== shipmentid)
      );
    } else {
      setSelectedShipments((prevSelected) => [...prevSelected, shipmentid]);
    }
  };

  const getSelectedShipmentData = () => {
    const selectedData = [];

    const selectedShipmentIds = new Set();

    filteredData.forEach((row) => {
      if (selectedShipments.includes(row.shipmentid)) {
        const inputValue = inputValues[row.shipmentid] || "";

        row.updatedQuantity.forEach((item) => {
          const totalValue = (item.approvedquantity * item.weight) / 1000;

          if (!selectedShipmentIds.has(row.shipmentid)) {
            selectedShipmentIds.add(row.shipmentid);

            const shipmentData = {
              orderId: row.shipmentid,
              numberOfBoxes: parseInt(inputValue),
              OrderDetails: [
                {
                  title: item.title,
                  approvedquantity: item.approvedquantity,
                  weight: item.weight,
                  totalBookWeight: totalValue,
                },
              ],
            };
            selectedData.push(shipmentData);
          } else {
            selectedData[selectedData.length - 1].OrderDetails.push({
              title: item.title,
              approvedquantity: item.approvedquantity,
              weight: item.weight,
              totalBookWeight: totalValue,
            });
          }
        });
      }
    });
    return selectedData;
  };

  const calculateTotalQuantity = () => {
    let totalQuantity = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalQuantity += item.approvedquantity;
        });
      }
    });

    return totalQuantity;
  };

  const calculateTotalWeight = () => {
    let totalWeight = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalWeight += (item.approvedquantity * item.weight) / 1000;
        });
      }
    });
    return totalWeight;
  };

  const calculateTotalBoxes = () => {
    let totalBoxes = 0;
    selectedShipments.forEach((shipmentId) => {
      const inputValue = inputValues[shipmentId];
      if (inputValue) {
        totalBoxes += parseInt(inputValue);
      }
    });
    return totalBoxes;
  };
  const totalBoxes = calculateTotalBoxes();
  useEffect(() => {
    setTotalQuantity(calculateTotalQuantity());
    setTotalWeight(calculateTotalWeight());
  }, [selectedShipments, filteredData]);

  const handleCreateShipment = () => {
    const areAllInputsFilled = selectedShipments.every((shipmentId) => {
      return Boolean(inputValues[shipmentId] && inputValues[shipmentId]());

    });

    if (!areAllInputsFilled) {
      alertify.alert("Please fill in the number of boxes for all selected shipments.");
      return;
    }

    setIsCreatingShipment(true);

    const selectedShipmentData = getSelectedShipmentData();
    const shipmentData = {
      totalBoxes,
      totalQuantity,
      totalWeight,
      ShipmentDetails: selectedShipmentData.map((shipment) => ({
        orderId: shipment.orderId,
        numberOfBoxes: shipment.numberOfBoxes,
        OrderDetails: shipment.OrderDetails.map((orderDetail) => ({
          title: orderDetail.title,

          approvedquantity: orderDetail.approvedquantity,
          totalBookWeight: orderDetail.totalBookWeight,
        })),
      })),
    };

 
    setSelectedShipments([]);
    setInputValues({});
    setSelectedShipmentId(null);


    const numRows = totalBoxes;
    navigate(`/ShipmentEarlyGenerate/${numRows}`, {
      state: { shipmentData },
    });

  };
  const selectedShipmentData = getSelectedShipmentData();
  return (
    <div className="createshipment">
      <h2>Create Shipment Early page</h2>
      <div className="shipmentcontainer">
      <div className="shipmentcontent">
      <Table className="shipmenttable"> 
        <thead>
          <tr>
            <th>Select</th>
            <th>Order ID</th>
            <th>Distributor Name</th>
            <th>Order Date</th>
            <th>Boxes</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row) => (
            <tr key={row.shipmentid}>
              <td>
                <input
                  type="checkbox"
                  checked={checkboxStatus[row.shipmentid] || false}
                  onChange={() => handleCheckboxChange(row.shipmentid)}
                />
              </td>
              <td>{row.shipmentid}</td>
              <td>{row.distributorName}</td>
              <td>{row.orderdate}</td>
              <td>
                <input
                  name="boxes"
                  type="number"
                  value={inputValues[row.shipmentid] || ""}
                  onChange={(e) =>
                    handleInputChange(row.shipmentid, e.target.value)
                  }
                  required={selectedShipmentId === row.shipmentid}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>
      </div>
      <h3>Selected Order:</h3>
      <Table>
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Title</th>
            <th>Quantity</th>
            <th>Weight(g) per Book</th>
            <th>Total Book Weight(Kg)</th>
            <th>Boxes</th>
          </tr>
        </thead>
        <tbody>
          {selectedShipmentData.map((shipment, index) => (
            <React.Fragment key={`${shipment.orderId}-${index}`}>
              {shipment.OrderDetails.map((orderDetail, detailIndex) => (
                <tr key={`${shipment.orderId}-detail-${detailIndex}`}>
                  {detailIndex === 0 ? (
                    <>
                      <td rowSpan={shipment.OrderDetails.length}>
                        {shipment.orderId}
                      </td>
                      <td>{orderDetail.title}</td>
                      <td>{orderDetail.approvedquantity}</td>
                      <td>{orderDetail.weight}</td>
                      <td>{orderDetail.totalBookWeight}</td>
                      <td rowSpan={shipment.OrderDetails.length}>
                        {shipment.numberOfBoxes}
                      </td>
                    </>
                  ) : (
                  
                    <>
                      <td>{orderDetail.title}</td>
                      <td>{orderDetail.approvedquantity}</td>
                      <td>{orderDetail.weight}</td>
                      <td>{orderDetail.totalBookWeight}</td>
                    </>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      <div>
        <td>Total Boxes: {totalBoxes}</td>
        <br />
        <td>Total Quantity: {totalQuantity}</td>
        <br />
        <td>Total Weight: {totalWeight.toFixed(2)}</td>
      </div>{" "}
      <button
        className="button-7"
        onClick={handleCreateShipment}
        disabled={isCreatingShipment}
      >
        {isCreatingShipment ? "Creating Shipment..." : "Create Shipment"}
      </button>
    </div>
  );
};

export default ShipmentEarly;
